<template>
  <div class="service-eval-page">
    <!-- 顶部轮播图 -->
    <div class="banner-swiper">
      <van-swipe :autoplay="false" indicator-color="white">
        <van-swipe-item v-for="(item, index) in bannerList" :key="index">
          <img :src="item" alt="轮播图" />
          <div class="swiper-count">{{ index + 1 }}/{{ bannerList.length }}</div>
        </van-swipe-item>
      </van-swipe>
    </div>

    <!-- 浮动头像 -->
    <div class="avatar-float" v-if="worker.name">
      <img :src="worker.image || defaultAvatar" alt="头像" class="avatar" />
    </div>

    <!-- 1. 工人信息卡片 -->
    <div class="info-card" v-if="worker.name">
      <div class="name-row">
        <span class="names2">{{ worker.name }}</span>
        <span class="tag" v-for="(h, hi) in (worker.honor_title_arr || [])" :key="'wh'+hi">{{ h }}</span>
      </div>
      <div class="desc-row">
        {{ worker.score }}分 | 从业{{ worker.work_years }}年 | 案例{{ worker.case_count }}套 | {{ worker.review_count }}条评价
      </div>
      <div class="w-company" v-if="worker.decoration_company">{{ worker.decoration_company }}</div>
      <div class="w-skill">{{ (worker.skills || []).join('、') }}</div>
    </div>

    <!-- 案例作品 -->
    <div class="case-section" v-if="caseList.length">
      <van-divider :style="{ borderColor: '#A3A3A3', color: '#A3A3A3', marginTop: '0px' }" />
      <div class="section-title">
        <span>案例作品</span>
        <div class="underline"></div>
      </div>
      <div class="case-item" v-for="(c, ci) in caseList" :key="ci">
        <div class="case-img-group" v-if="c.image_url_json && c.image_url_json.length">
          <div class="main-img">
            <img :src="c.image_url_json[0]" alt="主图" />
          </div>
          <div class="sub-img-group" v-if="c.image_url_json.length > 1">
            <img :src="c.image_url_json[1]" alt="子图1" class="sub-img" />
            <img :src="c.image_url_json.length > 2 ? c.image_url_json[2] : c.image_url_json[1]" alt="子图2" class="sub-img" />
          </div>
        </div>
        <div class="case-info">
          <div class="case-tag">{{ (c.style_category || []).join('、') || '现代风格' }} | {{ c.house || '' }} | {{ (c.acreage || '') + '㎡' }}</div>
          <div class="case-title">{{ c.title || '' }}</div>
        </div>
      </div> 
    </div>

    <!-- 2. 评价维度矩阵 -->
    <div class="page-title" style="margin-top: 10px;">服务评价</div>
    <div class="eval-matrix">
      <div v-for="(item, index) in evalDimensions" :key="index" class="matrix-row">
        <div class="label">{{ item.label }}</div>
        <div class="options">
          <div
            v-for="opt in item.options"
            :key="opt"
            class="option-btn"
            :class="{ active: item.selected === opt }"
          >
            {{ opt }}
          </div>
        </div>
      </div>
    </div>

    <van-divider :style="{ borderColor: '#A3A3A3', color: '#A3A3A3', marginTop: '20px' }" />

    <!-- 3. 评论列表 -->
    <div class="comment-list">
      <van-pull-refresh v-model="reviewRefreshing" @refresh="onReviewRefresh">
        <van-list
          v-model="reviewLoading"
          :finished="reviewFinished"
          finished-text="没有更多了"
          :immediate-check="false"
          @load="onReviewLoad"
        >
          <div v-for="(comment, idx) in reviewList" :key="idx" class="comment-item">
            <div class="user-header">
              <img :src="comment.user_avatar || defaultAvatar" class="avatar" />
              <div class="info">
                <div class="names1">{{ comment.user_name }}</div>
                <div class="stars">
                  <van-icon name="star" :color="n <= comment.score ? '#FFC107' : '#eee'" size="14" v-for="n in 5" :key="n" />
                </div>
              </div>
              <div class="meta">
                <div class="date">{{ comment.created_at }}</div>
              </div>
            </div>
            <div class="content-text">{{ comment.content }}</div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>

    <!-- <div class="loading-more">...</div> -->

    <!-- 4. 底部栏 -->
    <div class="bottom-bar-box">
        <div class="bottom-bar">
      <div class="action-contact">
        <img class="action-contact-img" src="/static/images/evalute/telephone.png" alt="">
        <span>联系方式</span>
      </div>
      <div class="btn-group">
        <div class="btn btn-red">在线咨询</div>
        <div class="btn btn-blue">我来点评</div>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      worker: {},
      defaultAvatar: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48Y2lyY2xlIGN4PSIzMCIgY3k9IjMwIiByPSIzMCIgZmlsbD0iI0U1RTVFNSIvPjxjaXJjbGUgY3g9IjMwIiBjeT0iMjMiIHI9IjgiIGZpbGw9IiNDQ0MiLz48cGF0aCBkPSJNMTUgNDVjMC04IDYtMTIgMTUtMTJzMTUgNCAxNSAxMiIgZmlsbD0iI0NDQyIvPjwvc3ZnPg==',
      evalDimensions: [
        { label: '报价准确', options: ['一般', '良好', '优秀'], selected: '优秀' },
        { label: '现场卫生', options: ['一般', '良好', '优秀'], selected: '优秀' },
        { label: '施工工期', options: ['一般', '良好', '优秀'], selected: '优秀' },
        { label: '施工质量', options: ['一般', '良好', '优秀'], selected: '优秀' },
      ],
      reviewList: [],
      reviewPage: 1,
      reviewLoading: false,
      reviewFinished: false,
      reviewRefreshing: false,
      caseList: [],
      bannerList: [],
    };
  },
  activated() {
    this.getDetail();
  },
  methods: {
    getDetail() {
      var id = this.$route.query.id;
      if (!id) return;
      this.$http.get('worker/detail', { params: { id: id } }).then(function (res) {
        var _json = res.data;
        if (_json.code == 200) {
          var d = _json.data;
          this.worker = d;
          this.bannerList = d.image ? [d.image] : ['https://via.placeholder.com/375x200'];
          if (d.evaluation) {
            this.evalDimensions[0].selected = this.scoreLabel(d.evaluation.price_score);
            this.evalDimensions[1].selected = this.scoreLabel(d.evaluation.hygiene_score);
            this.evalDimensions[2].selected = this.scoreLabel(d.evaluation.timeline_score);
            this.evalDimensions[3].selected = this.scoreLabel(d.evaluation.quality_score);
            this.getReviews();
          }
          this.getCaseList();
        }
      }.bind(this));
    },
    getCaseList() {
      var id = this.$route.query.id;
      if (!id) return;
      this.$http.get('worker/caseList', { params: { worker_id: id } }).then(function (res) {
        var _json = res.data;
        if (_json.code == 200) {
          this.caseList = _json.data.list || [];
        }
      }.bind(this));
    },
    getReviews(page) {
      var id = this.$route.query.id;
      if (!id) return;
      var p = page || 1;
      this.$http.get('worker/reviews', { params: { worker_id: id, page: p, pageSize: 10 } }).then(function (res) {
        var _json = res.data;
        if (_json.code == 200) {
          var list = _json.data.list || [];
          if (p === 1) {
            this.reviewList = list;
          } else {
            this.reviewList = this.reviewList.concat(list);
          }
          this.reviewFinished = _json.data.pagination ? !_json.data.pagination.has_more : true;
        }
        this.reviewLoading = false;
        this.reviewRefreshing = false;
      }.bind(this)).catch(function () {
        this.reviewLoading = false;
        this.reviewRefreshing = false;
      }.bind(this));
    },
    onReviewLoad() {
      if (this.reviewRefreshing || this.reviewFinished) return;
      this.reviewPage++;
      this.getReviews(this.reviewPage);
    },
    onReviewRefresh() {
      this.reviewPage = 1;
      this.reviewFinished = false;
      this.reviewRefreshing = true;
      this.getReviews(1);
    },
    scoreLabel(score) {
      if (score == 3 || score === '3') return '优秀';
      if (score == 2 || score === '2') return '良好';
      return '一般';
    },
  },
};
</script>

<style scoped>
.service-eval-page {
  padding-bottom: 70px;
  background-color: #fff;
  min-height: 100vh;
}

/* 顶部轮播图 */
.banner-swiper {
  position: relative;
  z-index: 0;
  width: 100%;
  height: 200px;
  overflow: hidden;
}
.banner-swiper img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.swiper-count {
  position: absolute;
  bottom: 10px;
  right: 15px;
  background-color: rgba(0, 0, 0, 0.5);
  color: #fff;
  font-size: 12px;
  padding: 2px 6px;
  border-radius: 4px;
}

/* 个人信息卡片 */
.info-card {
  position: relative;
  z-index: 1;
  margin-top: -40px;
  background-color: #fff;
  border-radius: 16px 16px 0 0;
  padding: 0 15px 0px;
}
.avatar-float {
  position: relative;
  z-index: 2;
  margin-top: -40px;
  margin-left: 15px;
  margin-bottom: -40px;
  width: 80px;
  height: 80px;
  border-radius: 50%;
  overflow: hidden;
  border: 3px solid #fff;
}
.avatar-float .avatar {
  position: relative;
  z-index: 1;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.name-row {
  display: flex;
  align-items: center;
  margin-top: 50px;
  margin-bottom: 8px;
}
.names2 {
  font-size: 18px;
  font-weight: 700;
  color: #1F1F1F;
  margin-right: 8px;
}
.tag {
  padding: 2px 6px;
  font-size: 12px;
  border-radius: 2px;
  color: #fff;
  background: url(/static/images/evalute/span-bg-d.png) no-repeat;
  background-position: 0 100%;
  background-size: cover;
}
.desc-row {
  font-size: 14px;
  color: #646566;
  padding-bottom: 15px;
}
.w-company { font-size: 12px; color: #969799; margin-bottom: 6px; }
.w-skill { font-size: 13px; color: #727272; background: #ECECEC; padding: 4px 8px; border-radius: 4px; display: inline-block; margin-bottom: 10px; }

/* 1. 标题 */
.page-title {
  text-align: center;
  font-size: 18px;
  font-weight: bold;
  padding: 15px 0;
  color: #333;
}

/* 2. 评价矩阵 */
.eval-matrix {
  padding: 0 15px;
}
.matrix-row {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}
.matrix-row .label {
  width: 80px;
  font-size: 14px;
  color: #1F1F1F;
  font-weight: 700;
}
.options {
  flex: 1;
  display: flex;
  justify-content: space-between;
}
.option-btn {
  flex: 1;
  text-align: center;
  padding: 6px 0;
  font-size: 13px;
  border-radius: 4px;
  margin-right: 8px;
  background-color: #f2f3f5;
  color: #646566;
}
.option-btn:last-child {
  margin-right: 0;
}
/* 选中态：橙色 */
.option-btn.active {
  background-color: #FF7800; /* 接近截图的橙色 */
  color: #fff;
}

/* 3. 评论列表 */
.comment-list {
  padding: 0 15px;
}
.comment-item {
  margin-bottom: 25px;
  border-bottom: 1px solid #f7f8fa;
  padding-bottom: 15px;
}
.user-header {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
.avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  margin-right: 10px;
}
.info {
  flex: 1;
}
.names1 {
  font-size: 14px;
  color: #333;
  margin-bottom: 4px;
}
.stars {
  display: flex;
}
.meta {
  text-align: right;
  font-size: 12px;
  color: #999;
}
.meta .area {
  margin-top: 4px;
}

.content-text {
  font-size: 14px;
  color: #333;
  line-height: 1.6;
  margin-bottom: 10px;
  display: flex;
  align-items: flex-start;
}
.content-text van-icon {
  margin-left: 4px;
  margin-top: 4px;
}

.image-grid {
  display: flex;
}
.grid-img {
  width: 100px;
  height: 100px;
  border-radius: 4px;
  margin-right: 10px;
  object-fit: cover;
}

.loading-more {
  text-align: center;
  color: #1989fa;
  font-size: 20px;
  letter-spacing: 2px;
  margin: 20px 0;
}

/* 案例作品 */
.case-section {
  padding: 10px 15px 10px;
}
.section-title {
  text-align: center;
  font-size: 20px;
  font-weight: 500;
  color: #323233;
  margin-bottom: 20px;
  position: relative;
}
.section-title .underline {
  width: 30px;
  height: 2px;
  background-color: #1989fa;
  margin: 8px auto 0;
}
.case-item {
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  overflow: hidden;
  margin-bottom: 10px;
}
.case-img-group {
  display: flex;
  gap: 4px;
}
.main-img {
  flex: 2;
  height: 240px;
  overflow: hidden;
}
.sub-img-group {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.sub-img {
  height: 118px;
  overflow: hidden;
}
.main-img img, .sub-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.case-info {
  padding: 12px;
}
.case-tag {
  font-size: 14px;
  color: #646566;
  margin-bottom: 8px;
}
.case-title {
  font-size: 16px;
  font-weight: 500;
  color: #323233;
}

/* 4. 底部固定栏 */
.bottom-bar-box{
    width: 100%;
    height: 80px;
    position: fixed;
    bottom: 0px;
    left: 0;
    background: #fff;
    padding-top: 20px;
}

.bottom-bar {
  width: 100%;
  height: 30px;
  background: #fff;
  display: flex;
  align-items: center;
  box-shadow: 0 -1px 5px rgba(0,0,0,0.05);
  z-index: 100;
  padding: 0 20px;
}
.action-contact {
  width: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  color: #666;
}
.action-contact img {
  width: 20px;
  height: 20px;
  margin-right: 4px;
}
.btn-group {
  flex: 1;
  display: flex;
  height: 100%;
  margin-left: 5px;
}
.btn {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 15px;
  font-weight: 500;
}
.btn-red {
  background-color: #D70D0D; /* Vant 默认红 */
  border-radius: 30px 0 0 30px;
}
.btn-blue {
  margin-left: 5px;
  background-color: #0960F0; /* Vant 默认蓝 */
  border-radius: 0 30px 30px 0;
}
</style>


// WEBPACK FOOTER //
// src/components/evaluate/workerDetails.vue